import React from 'react';
import { getContentSvtId, getContentUrl } from '../../../utils/contentoUtils';
import get from '../../../utils/get';
import { createImageProxyTemplate, formatImageProxyUrl } from '../../../utils/svtimage';
import { CARD_TYPE } from '../ContentItemCarousel';
import {
    CarouselContentItem,
    CarouselPromotionItem,
    CarouselShowcaseCard,
} from '../ContentItemCarousel.styles';
import { getProgress } from '../helpers';
import { PLAY_BADGE_SIZE } from '../../PlayBadge/PlayBadge';

const ItemsList = (props) => {
    const {
        items,
        editModeActivated = false,
        location,
        presentation,
        preferredAccessVersion,
        onItemClick,
        onMarkItemAsDeleted,
        continueWatchingIsActive,
        continueWatchingItems,
        markedAsDeleted = [],
        isInSweden,
        cardType,
        currentAccessibilityChoiceContento,
        autoPlay,
        playingNowId,
        linkToDetailsPage,
        hasHero = true,
    } = props;

    return (
        <>
            {items.map((content, i) => {
                const id = content.id || content.item?.id;
                if (cardType === CARD_TYPE.SHOWCASE) {
                    const url = getContentUrl(content.item, currentAccessibilityChoiceContento);

                    return (
                        <CarouselShowcaseCard
                            key={id}
                            item={content}
                            url={url}
                            index={hasHero ? i + 1 : i} // Offset with one due to Hero being in position 1
                            srcSet={content.srcSet}
                            onItemClick={onItemClick}
                            badgeSize={PLAY_BADGE_SIZE.MEDIUM}
                        />
                    );
                }

                if (cardType === CARD_TYPE.PROMOTION) {
                    const promoItem = {
                        urlPart: `/genre/${id}`,
                        posterImageUrl: content.image
                            ? formatImageProxyUrl(
                                  createImageProxyTemplate(content.image.id, content.image.changed),
                                  'medium',
                                  480
                              )
                            : '',
                        posterAltText: get(content, 'image.description', ''),
                        name: content.name,
                    };

                    return (
                        <CarouselPromotionItem
                            item={promoItem}
                            key={`promotion-item-${id}`}
                            index={i + 1}
                            expanded={false}
                        />
                    );
                }

                const itemIsMarkedAsDeleted = () => {
                    if (markedAsDeleted.length === 0) {
                        return false;
                    }

                    const markedItemIndex = markedAsDeleted.findIndex((item) => item.videoId === id);

                    return markedItemIndex > -1;
                };

                const contentItemIndex = i + 1;

                const isPlayingNow =
                    getContentSvtId(content.svtId ? content : content.item, preferredAccessVersion) ===
                    playingNowId;

                return (
                    <CarouselContentItem
                        inView
                        index={contentItemIndex}
                        key={id}
                        content={content}
                        listId={id}
                        preferThumbnail={false}
                        editModeActivated={editModeActivated}
                        markedAsDeleted={itemIsMarkedAsDeleted()}
                        location={location}
                        presentation={presentation}
                        preferredAccessVersion={preferredAccessVersion}
                        progress={getProgress(content, continueWatchingIsActive, continueWatchingItems)}
                        onMarkedAsDeleted={onMarkItemAsDeleted}
                        onClick={onItemClick}
                        loadImage
                        itemPosition={contentItemIndex}
                        isInSweden={isInSweden}
                        autoPlay={autoPlay}
                        playingNow={isPlayingNow}
                        linkToDetailsPage={linkToDetailsPage}
                    />
                );
            })}
        </>
    );
};

export default ItemsList;
